<template>
    <div>
          <v-layout wrap justify-center align-center>
              <v-flex xs12 sm7 md7>
                  <dialogos-app :dialogos="dialogos" tucan="0" diagCenter="true"></dialogos-app>
              </v-flex>
          </v-layout>
          <v-layout wrap row justify-center align-center text-xs-center class="cont_page mt-10">
            <v-flex xs12 md5 class="cont-button">
              <button class="button-unidad hvr hvr-scale">
                <div class="cont-icono animated flipInY dura-2">
                  <img :src="require('@/assets/presentacion/unidad-1.png')" alt="">
                </div>
                <div class="cont-name animated fadeInUp dura-2" :style="{'background':btnColors[0]}">
                  <h3 class="t-first">Unidade 1</h3>
                </div>
              </button>
            </v-flex>
          </v-layout>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Bem-vindo à <strong>Unidade 1.</strong>'
      ],
      btnColors:[
        '#65B8FF','#F78B00','#EA5E00','#E13510'
      ],
      iconActive: [true,false,false,false]
    }
  },
  methods: {
    goToModulo(val){
      this.$router.push('/unidad'+val+'/0')
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.mt-10{
  margin-top: 10vh;
}
.button-unidad{
  text-align: center;
  margin: 0 auto;
  margin-bottom: 10px;
  div{
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
  }
  .cont-icono{
    img{
       width: 150px;
    }
  }
  .cont-name{
    padding: 10px 35px;
    border-radius: 24px;
  }
}
.t-first{
   font-family:Poppins-Bold;
   font-size: 30px;
   margin: 0;
   padding: 0;
}
</style>
